import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toddlerBedtime: BlogMetaData = {
  title: '寝かしつけのコツ｜1〜3歳が寝ない理由と年齢別の環境づくり',
  description:
    '1〜3歳の寝かしつけのコツを、年齢別の寝ない理由、生活リズム、入眠儀式、寝室の安全、相談目安まで園長が解説。イヤイヤ期にも取り入れやすい関わり方を紹介します。',
  thumbnailUrl: '/img/blog-toddler-bedtime.webp',
  filePath: buildBlogFilePath('toddler-bedtime'),
  category: BLOG_CATEGORY.PARENTING,
};
